module.exports = __webpack_public_path__ + "static/media/29FUNOV7.4f7cab67.jpg";